import React from 'react';

import moment from 'moment';

import Section from 'components/Section';
import TimelineItem from 'components/TimelineItem';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { ReportLog } from 'models/reportSummary';
import { getFormattedPrice } from 'utils/currency';
import { htmlT } from 'utils/generic';

import { Container, TimelineContainer } from './styles';

interface Props {
  date?: Date;
  reports: ReportLog[];
}

const ReportTimeline = ({ reports, date }: Props) => {
  const { t } = useStoreTranslation();
  const getIcon = (type: string) =>
    type.toLowerCase() === 'flight' ? '/corporate/images/mini-plane-circle.svg' : '/corporate/images/bedroom-circle.svg';
  const getPrice = (item: ReportLog) => {
    const formattedPrice = (value: number | undefined) => {
      const { formatted } = getFormattedPrice({ value, currency: item.currencyCode, t });
      return formatted;
    };
    return formattedPrice(item.value);
  };

  return (
    <Container>
      <Section title={htmlT(t, 'travelReport.timelineTitle', { date: moment(date).format('MMMM YYYY') })} joinContent>
        <TimelineContainer>
          {reports.map((item, index) => (
            <TimelineItem
              key={index.toString()}
              date={item.date}
              title={
                <>
                  <span>{item.description}</span>
                  <span>{getPrice(item)}</span>
                </>
              }
              description={
                <>
                  <span>{item.group}</span>
                  <span>{item.name}</span>
                </>
              }
              icon={getIcon(item.type)}
              noSeparator={index === reports.length - 1}
            />
          ))}
        </TimelineContainer>
      </Section>
    </Container>
  );
};

export default ReportTimeline;
